import api from './api'

export default class BaseService {
  static getSession () {
    return api.get('/session', {
      params: {
        redirect_uri: window.location.href
      }
    })
  }

  static restoreSession (redirectUri) {
    return api.post('/session', {
      redirect_uri: redirectUri
    })
  }

  static startAuthorization (method, credentials) {
    const data = {}
    if (method) {
      data.method = method
    }
    if (credentials && credentials.length) {
      data.credentials = credentials
    }
    return api.post('/start-authorization', data)
  }

  static continueAuthorization (data) {
    if (data === undefined) {
      data = {}
    }
    return api.post('/continue-authorization', data)
  }

  static cancelAuth () {
    return api.post('/cancel-authorization')
  }

  static notifyLeaving () {
    return api.post('/leaving')
  }

  static confirmConsent () {
    return api.post('/confirm-consent')
  }
}
